"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDateInputExampleCodeSegments = exports.GKDateInputExample = void 0;
// <copy>
var react_1 = __importDefault(require("react"));
var components_1 = require("../../components");
var date_1 = require("@internationalized/date");
var GKDateInputExample = function () {
    var initialDate = "2022-05-15";
    var _a = react_1.default.useState(initialDate), currentDate = _a[0], setCurrentDate = _a[1];
    return (react_1.default.createElement("div", { className: "w-25" },
        react_1.default.createElement(components_1.GKDateInput, { id: "testID", "data-qa": "testQA", label: "Select a Date", defaultValue: (0, date_1.parseDate)(initialDate), minValue: (0, date_1.parseDate)("2022-01-15"), maxValue: (0, date_1.parseDate)("2022-12-15"), onChange: function (date) { return setCurrentDate(date === null || date === void 0 ? void 0 : date.toString()); } }),
        react_1.default.createElement("p", null,
            "Selected date: ",
            currentDate)));
};
exports.GKDateInputExample = GKDateInputExample;
// </copy>
// AUTOGENERATED:
/* eslint-disable prettier/prettier */
exports.GKDateInputExampleCodeSegments = ["import React from \"react\";\nimport { GKDateInput } from \"../../components\";\nimport { parseDate } from \"@internationalized/date\";\nexport const GKDateInputExample: React.FC = () => {\n  const initialDate = \"2022-05-15\";\n  const [currentDate, setCurrentDate] = React.useState(initialDate);\n  return (\n    <div className=\"w-25\">\n      <GKDateInput\n        id=\"testID\"\n        data-qa=\"testQA\"\n        label=\"Select a Date\"\n        defaultValue={parseDate(initialDate)}\n        minValue={parseDate(\"2022-01-15\")}\n        maxValue={parseDate(\"2022-12-15\")}\n        onChange={(date) => setCurrentDate(date?.toString())}\n      />\n      <p>Selected date: {currentDate}</p>\n    </div>\n  );\n};"];
/* eslint-enable prettier/prettier */
